import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { ChangeUserPasswordByAdmin } from "../../../services/security.service";

const ChangePassword = () => {
  const [showPass, setShowPass] = useState(false);
  const [showRepeatPass, setRepeatShowPass] = useState(false);
  const initialValues = {
    newUserPassword: "",
    repeatNewUserPassword: "",
  };
  const passwordValidation = Yup.object().shape({
    newUserPassword: Yup.string()
      .ensure()
      .required("لطفا رمز عبور جدید را وارد نمایید.")
      .matches(/^(?=.*[a-z])/, "باید شامل یک حرف کوچک باشد")
      .matches(/^(?=.*[A-Z])/, "باید شامل یک حرف بزرگ باشد")
      .matches(/^(?=.*[0-9])/, "باید شامل یک عدد باشد.")
      .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
    repeatNewUserPassword: Yup.string()
      .ensure()
      .oneOf([Yup.ref("newUserPassword"), null], "با رمز عبور جدید یکسان نیست.")
      .required("لطفا رمز عبور جدید را مجددا تکرار نمایید."),
  });

  const history = useHistory<{ permissionUserId: number }>();
  const userId =
    history?.location?.state?.permissionUserId !== undefined
      ? history?.location?.state?.permissionUserId
      : Number(window.localStorage.getItem("PermissionUserId"));

  const { mutate: changePasswordMutate } = useMutation(
    ChangeUserPasswordByAdmin,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success("رمز با موفقیت تغییر یافت");
        }
      },
      onError: () => {},
    }
  );

  const submitPassword = (
    values: { newUserPassword: string },
    { resetForm }: any
  ) => {
    changePasswordMutate({
      newPassword: values.newUserPassword,
      userId: userId,
    });
    resetForm();
  };
  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      gap={"2.5rem"}
      sx={{ marginTop: "2.5rem" }}
    >
      <Grid item xs={12}>
        <Typography
          sx={{ textAlign: "center", color: "#212121", fontSize: "1.3rem" }}
        >
          جهت تغییر کلمه عبور کاربر، <b>"کلمه عبور جدید"</b> را وارد کنید.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          onSubmit={submitPassword}
          validateOnMount={true}
          validationSchema={passwordValidation}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid
                container
                direction={"column"}
                gap={"2rem"}
                width={{ xs: "200px", sm: "300px", md: "350px" }}
              >
                <Grid
                  item
                  xs={12}
                  display={"flex"}
                  gap={"2rem"}
                  flexDirection={"column"}
                >
                  {/* this input is for prevent autofill in Firefox */}
                  <input
                    value=""
                    name="prevent_autofill"
                    id="prevent_autofill"
                    type="password"
                    style={{ display: "none" }}
                  />
                  <MaterialTextFieldComponent
                    placeHolder={"کلمه عبور جدید"}
                    label={"کلمه عبور جدید"}
                    name={"newUserPassword"}
                    id={"newUserPassword"}
                    helperText={
                      touched.newUserPassword ? errors.newUserPassword : ""
                    }
                    error={
                      touched.newUserPassword && Boolean(errors.newUserPassword)
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.newUserPassword}
                    required={true}
                    type={!showPass ? "password" : ""}
                    onKeyDown={(e) => {
                      if (/^[آ-ی ء چ]+$/.test(e.key) && e.code !== "Space") {
                        e.preventDefault();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onMouseDown={() => setShowPass(!showPass)}
                            onMouseUp={() => setShowPass(!showPass)}
                          >
                            {showPass ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <MaterialTextFieldComponent
                    placeHolder={"تکرار کلمه عبور"}
                    label={"تکرار کلمه عبور"}
                    name={"repeatNewUserPassword"}
                    id={"repeatNewUserPassword"}
                    helperText={
                      touched.repeatNewUserPassword
                        ? errors.repeatNewUserPassword
                        : ""
                    }
                    error={
                      touched.repeatNewUserPassword &&
                      Boolean(errors.repeatNewUserPassword)
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.repeatNewUserPassword}
                    required={true}
                    type={!showRepeatPass ? "password" : ""}
                    onKeyDown={(e) => {
                      if (/^[آ-ی ء چ]+$/.test(e.key) && e.code !== "Space") {
                        e.preventDefault();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onMouseDown={() =>
                              setRepeatShowPass(!showRepeatPass)
                            }
                            onMouseUp={() => setRepeatShowPass(!showRepeatPass)}
                          >
                            {showRepeatPass ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disabled={
                      !values.newUserPassword ||
                      !values.repeatNewUserPassword ||
                      Boolean(errors.repeatNewUserPassword)
                    }
                    className={
                      !values.newUserPassword ||
                      !values.repeatNewUserPassword ||
                      Boolean(errors.repeatNewUserPassword)
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                  >
                    تغییر کلمه عبور
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;
